import { OpenPosition } from 'types/IOpenPosition';
import { ContractType } from 'types/IProducts';

import { isOptions } from './assetUtils';

export const getUnrealisedPnlFromApi = (position?: OpenPosition) => {
  if (!position) return 0;

  const {
    product,
    unrealized_pnl: unrealizedPnlFromApi,
    realized_cashflow: realizedCashflowFromAPI,
  } = position;

  if (
    product?.contract_type === ContractType.Tracker ||
    isOptions(product?.contract_type)
  ) {
    return Number(unrealizedPnlFromApi) - Number(realizedCashflowFromAPI);
  }

  return Number(unrealizedPnlFromApi); // for futures
};
